import { api } from '@/api'
import type { LeadItem } from '@/api/typings/lead.typing'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export function getLeadsAction(params: Record<string, any>): Promise<ApiPaginationResponse<LeadItem[]>> {
  const { page, ...filters } = params

  const queryParams: Record<string, any> = { page }
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== '' && value !== undefined) {
      queryParams[`filter[${key}]`] = value
    }
  })

  return api.get<ApiPaginationResponse<LeadItem[]>>('/leads', { params: queryParams })
}
